'use strict';

var React = require('react');
var SectionHeader = require('../Common/SectionHeader');
var InvestmentOptionSearch = require('./InvestmentOptionSearch');
var ModelPortfolio = require('./ModelPortfolio');
var InvestmentAllocatedTable = require('./InvestmentAllocatedTable');
var InlineError = require('../Common/InlineError');
var UserNotification = require('../Common/UserNotification.jsx');
var Formatter = require('../../utils/Formatter.js');
var InvestmentAllocationStore = require('../../stores/InvestmentAllocationStore');
var InvestmentOptionStore = require('../../stores/InvestmentOptionStore');
var ModelPortfolioStore = require('../../stores/ModelPortfolioStore');
var ClassNames = require('classnames');
var InvestmentAllocationActions = require('../../actions/InvestmentAllocationActions');
var ApplicationActions = require('../../actions/ApplicationActions');
var ApplicationStore = require('../../stores/ApplicationStore.js');
var appConstants = require('../../constants/ApplicationConstants.js');
var Formatter = require('../../utils/Formatter.js');
var ProductIds = appConstants.ProductIds;
var _focused = false;
var RadioInput = require('../Common/RadioInput.jsx');
var FundingYourProductStore = require('../../stores/FundingYourProductStore.js');
var Constants = require('../../constants/FundingYourProductConstants.js');
var InlineMessage = require('../Common/InlineMessage.jsx');
var RadioButton = require('../Common/RadioButton.jsx');
const { ErrorCodes } = require('../../constants/ApplicationConstants.js');
var ValidationTypes = appConstants.ValidationTypes;

// Method to retrieve state from Stores
function getStateFromStores() {
    return {
        modelPortfolioList: ModelPortfolioStore.getList(),
        portFolioPlaceHolder: ModelPortfolioStore.getPortfolioPlaceHolder(),
        portFolioDisable: ModelPortfolioStore.getPortfolioDisable(),
        investmentOptionList: InvestmentOptionStore.getList(),
        firstRateCashNonAutoRebalancingOptionsList: InvestmentOptionStore.getFirstRateCashNonAutoRebalancingOptions(),
        allocatedInvestmentOptions: InvestmentAllocationStore.getList(),
        investmentOptionsSearchIsVisible: InvestmentOptionStore.searchVisible(),
        selectedModelPortfolio: ModelPortfolioStore.getSelected(),
        investmentListAvailable: InvestmentAllocationStore.investmentListAvailable(),
        investmentAllocationTotal: InvestmentAllocationStore.getTotal(),
        validationError: InvestmentAllocationStore.getValidationError(),
        mPValidationError: ModelPortfolioStore.getMpValdationError(),
        validationType: InvestmentAllocationStore.getValidationType(),
        mPValidationType: ModelPortfolioStore.getMpValidationType(),
        isHideError: InvestmentAllocationStore.isHideError(),
        hideModelPortfolio: ApplicationStore.hideModelPortfolio(),
        termDepositMessage: InvestmentAllocationStore.termDepositMessage(),
        hideInvestmentAllocation: InvestmentAllocationStore.getHideSectionDueToInSpecieOrPensionType(),
        isConsolidateTermDeposit: InvestmentAllocationStore.isConsolidateTermDeposit(),
        isAllocationSaved: InvestmentAllocationStore.isAllocationSaved(),
        isInvestmentAllocationLimit: InvestmentAllocationStore.getIsInvestmentAllocationLimit(),
        crossSectionDependencyMsg: InvestmentAllocationStore.getCrossSectionDependencyMsg(),
        isAdd: InvestmentOptionStore.getIsAddInvestmentOption(),
        isManagedAccount: ModelPortfolioStore.getIsManagedAccount(),
        isUserNotificationClosed: false,
        activeFundType: FundingYourProductStore.getActiveFundType(),
        hasAnyInternalRollover: FundingYourProductStore.getHasInternalRollover(),
        isPreRetirement: InvestmentOptionStore.getIsPreRetirement(),
        isAcknowledged: InvestmentAllocationStore.isInvestmentAllocationAcknowledged(),
        isHideAcknowledgementError: InvestmentAllocationStore.isHideAcknowledgementError(),
        isHideAcknowledgementSection: InvestmentAllocationStore.isHideAcknowledgementSection(),
        firstRateCashNonAutoRebalancing : InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing(),
        isAssetAllocationVisible: InvestmentAllocationStore.isAssetAllocationVisible(),
        areCashOptionsVisible: InvestmentAllocationStore.areCashOptionsVisible(),
        showFirstRateCashNonAutoRebalancing: InvestmentAllocationStore.showFirstRateCashNonAutoRebalancing()
    };
}

// Controller View Component for Investment Allocation
var InvestmentAllocationSection = React.createClass({
    getInitialState: function () {   
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        InvestmentAllocationStore.addChangeListener(this._onChange);
        InvestmentOptionStore.addChangeListener(this._onChange);
        ModelPortfolioStore.addChangeListener(this._onChange);
        ApplicationStore.addChangeListener(this._onChange);
        FundingYourProductStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        InvestmentAllocationStore.removeChangeListener(this._onChange);
        InvestmentOptionStore.removeChangeListener(this._onChange);
        ModelPortfolioStore.removeChangeListener(this._onChange);
        ApplicationStore.removeChangeListener(this._onChange);
        FundingYourProductStore.removeChangeListener(this._onChange);
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (nextState.isManagedAccount !== this.state.isManagedAccount) {
            ApplicationActions.sendIsManagedAccount(nextState.isManagedAccount);
        } 
    },

    //Event handler for 'change' events coming from the stores
    _onChange: function() {
        this.setState(getStateFromStores());
    },

    setTermDeposit: function (e) {
        InvestmentAllocationActions.selectConsolidateContributionsForTermDeposits(e.target.value);
    },

    toggleFirstRateCashNonAutoRebalancingOption: function (e) {
        InvestmentAllocationActions.toggleFirstRateCashNonAutoRebalancingOption(e.target.value);
    },

    handleClick: function () {
        _focused = true;
        InvestmentAllocationActions.toggleSearchVisibility(true);
        InvestmentAllocationActions.toggleIsAddInvestmentOption(true);
    },

    handleOffFocusedInvestmentSearch: function (val) {
        _focused = val;
    },

    getCrossSectionMsg: function () {
        var crossSectionMsg = Formatter.formatString(this.props.content.crossSectionParentText, { parentSection: this.props.content.investmentAllocation.sectionHeader, sections: _.pluck(this.state.crossSectionDependencyMsg, 'content').join(', ') });

        return crossSectionMsg;
    },

    toggleUserNotificationClose: function () {        
        this.setState({ isUserNotificationClosed: true, crossSectionDependencyMsg: this.state.crossSectionDependencyMsg.splice(0, this.state.crossSectionDependencyMsg.length) });
    },

    toggleIsAdd: function (val) {
        InvestmentAllocationActions.toggleIsAddInvestmentOption(val);
    },

    updateAcknowledgement: function (e) {
        InvestmentAllocationActions.updateInvestmentAllocationAcknowledgment(e.target.value);
    },

    render: function () {
        let errorHeader, errorMessage, highlightInput = false;
        let acknowledgementErrorMessage, acknowledgementLabel = this.props.content.investmentAllocation.acknowledgementLabel;
        let mPIsHideError = true;
        let investmentAllocationTitle = '';
        let investmentAllocationPlaceHolder = '';

        if(this.props.productId === ProductIds.PENSION && this.state.isPreRetirement){
            investmentAllocationTitle= 'Will you be selecting the FirstRate TTR Saver Non-Auto-rebalancing option?';
            investmentAllocationPlaceHolder='FirstRate TTR Saver Non-Auto-rebalancing option';
        }else if(this.props.productId === ProductIds.PENSION && !this.state.isPreRetirement){
            investmentAllocationTitle= 'Will you be selecting FirstRate Saver Non-Auto-rebalancing option and/or term deposits?';
            investmentAllocationPlaceHolder='FirstRate Saver Non-Auto-rebalancing option or term deposits';
        }else if(this.props.productId === ProductIds.INVESTMENT){
            investmentAllocationTitle= 'Will you be selecting the FirstRate Cash Non-Auto-rebalancing option?';
            investmentAllocationPlaceHolder='FirstRate Cash Non-Auto-rebalancing option';
        }else if(this.props.productId === ProductIds.SUPER){
            investmentAllocationTitle= 'Will you be selecting FirstRate Saver Non-Auto-rebalancing option and/or term deposits?';
            investmentAllocationPlaceHolder='FirstRate Saver Non-Auto-rebalancing option or term deposits';
        }

        if(this.props.productId === ProductIds.PENSION && this.state.mPValidationError === ErrorCodes.ManagedAccountOrModelPortfolios){
            mPIsHideError = false;
        }

        if (!this.state.isAcknowledged && !this.state.isHideAcknowledgementSection) {
            acknowledgementErrorMessage = this.props.content.investmentAllocation.acknowledgementIsRequiredError;
        } else {
            this.state.isHideAcknowledgementError = true;
        }
       
        if (this.state.validationError === appConstants.ErrorCodes.TotalIsNot100 && !this.state.isHideError || this.state.validationError === appConstants.ErrorCodes.AtLeastOne) {
            errorHeader = this.props.content.investmentAllocation.totalMustBe100RequiredErrorHeading;
            errorMessage = this.props.content.investmentAllocation.totalMustBe100RequiredError;
            highlightInput = true;
        }
        else if (this.state.validationError === appConstants.ErrorCodes.WithNonZeroValue) {
            errorHeader = this.props.content.investmentAllocation.mustHaveNoZeroValueRequiredErrorHeading;
            errorMessage = this.props.content.investmentAllocation.mustHaveNoZeroValueRequiredError;
        }
        else if (this.state.validationError === appConstants.ErrorCodes.Diversification) {
            if (this.props.productId === ProductIds.SUPER || this.props.productId === ProductIds.PENSION) {
                errorHeader = this.props.content.investmentAllocation.diversificationCopyHeading;
                errorMessage = this.props.content.investmentAllocation.diversificationCopy;
            }
            else if (this.props.productId === ProductIds.INVESTMENT) {
                errorHeader = this.props.content.investmentAllocation.investmentDiversificationHeading;
                errorMessage = this.props.content.investmentAllocation.investmentDiversification;
            }
            else {
                this.state.isHideError = true;
            }
            highlightInput = false;
        }

        if (this.props.productId !== ProductIds.SUPER) {
            this.state.termDepositMessage = true;
        }
        return (
             <div className="investment-allocation-section">
                <div className={ClassNames('form-step', { hidden: this.state.hideInvestmentAllocation })} id="investment-allocation">
                    <SectionHeader focus={this.props.focus} sectionName="Investment allocation" sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={this.props.content.investmentAllocation.sectionHelp} />
                    <div className="container">
                        <UserNotification id="investmentAllocationUserNotification"
                            message={this.getCrossSectionMsg()}
                            onClick={this.toggleUserNotificationClose}
                            isHidden={!this.state.crossSectionDependencyMsg.length || this.state.isUserNotificationClosed} />
                             <div className="form-section form-autocomplete">
                           {this.state.showFirstRateCashNonAutoRebalancing && (
                           <div id="first-rate-cash-non-auto-rebalancing">
                                <RadioInput id="firstRateCashNonAutoRebalancing"
                                            model="isfirstRateCashNonAutoRebalancing"
                                            customClass="firstRateCashNonAutoRebalancing__question"
                                            data={appConstants.YesNoRadioData}
                                            value={this.state.firstRateCashNonAutoRebalancing}
                                            label={investmentAllocationTitle}
                                            onChange={this.toggleFirstRateCashNonAutoRebalancingOption} />           
                                          
                            </div>)}
                            <div id="first-rate-cash-non-auto-rebalancing-options" className={ ClassNames('pull-left investment-option-search-container', { hidden: !this.state.areCashOptionsVisible })}>
                                    <InvestmentOptionSearch placeholderText={investmentAllocationPlaceHolder}
                                                                    isSearchVisible={true}
                                                                    investmentOptionsList={this.state.firstRateCashNonAutoRebalancingOptionsList}
                                                                    isFocused={_focused}
                                                                    handleOffFocusedInvestmentSearch={this.handleOffFocusedInvestmentSearch} toggleIsAdd={this.toggleIsAdd} />
                                    <div className="clearfix"></div>
                             </div>
                            <div className={ClassNames({ hidden: !this.state.isAssetAllocationVisible })}>
                                <div className="form-label-section">
                                    <label htmlFor="investment-allocation" dangerouslySetInnerHTML={{ __html: this.props.content.investmentAllocation.investmentAllocationHeading}}></label>
                                </div>
                                <InlineMessage key="investmentAllocationPreRetirementSwitchToCashNote"
                                        id="investmentAllocationPreRetirementSwitchToCashNote" 
                                        customClass="investmentAllocation-message-marginTopMed"
                                        type="info"
                                        message={this.props.content.investmentAllocation.investmentAllocationSwitchToCashNote}
                                        isHidden={ !(this.state.isPreRetirement && (this.state.activeFundType === Constants.FundingTypes.Internal_rollover || this.state.hasAnyInternalRollover))} />
                            
                                <div id="investment-search-init">
                                    <InvestmentAllocatedTable investmentListAvailable={this.state.investmentListAvailable}
                                                                allocatedInvestmentOptions={this.state.allocatedInvestmentOptions}
                                                                highlightInput={highlightInput} hasError={this.state.isHideError} isAdd={this.state.isAdd} toggleIsAdd={this.toggleIsAdd} toggleUserNotificationClose={this.toggleUserNotificationClose} />
                                    
                                        <div className={ ClassNames('pull-left investment-option-search-container', { hidden: !this.state.investmentOptionsSearchIsVisible }, { 'with-border': !this.state.investmentListAvailable }) }>
                                            <InvestmentOptionSearch placeholderText="Search by investment name or code"
                                                                    isSearchVisible={this.state.investmentOptionsSearchIsVisible}
                                                                    investmentOptionsList={this.state.investmentOptionList}
                                                                    isFocused={_focused}
                                                                    handleOffFocusedInvestmentSearch={this.handleOffFocusedInvestmentSearch} toggleIsAdd={this.toggleIsAdd} />
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className={ ClassNames('pull-left investment-option-totalbar investment-option-separator', { hidden: (this.state.isInvestmentAllocationLimit) }) }>
                                            <div className={ ClassNames('pull-left', { 'add-fund': !(this.state.investmentOptionsSearchIsVisible || this.state.isInvestmentAllocationLimit) }, { hidden: (this.state.investmentOptionsSearchIsVisible || this.state.isInvestmentAllocationLimit) }) }>
                                                <button id="add-fund" type="button" className={ ClassNames('btn btn-default btn-lg', { hidden: (this.state.investmentOptionsSearchIsVisible) }) } onClick={this.handleClick}>+ Add fund</button>
                                            </div>
                                            <div className={ClassNames({ 'pull-left model-portfolio-container investment-option-totalbar': !this.state.hideModelPortfolio }, { hidden: this.state.hideModelPortfolio }, { 'no-padding': this.state.investmentOptionsSearchIsVisible })}>
                                                <ModelPortfolio placeholderText={this.state.portFolioPlaceHolder}
                                                                modelPortfolioList={this.state.modelPortfolioList}
                                                                isDisable={this.state.portFolioDisable}
                                                                selectedModelPortfolio={this.state.selectedModelPortfolio}
                                                                allocatedInvestmentOptions={this.state.allocatedInvestmentOptions} />
                                            </div>
                                            <div className={ClassNames({'col-md-10 col-sm-10': this.state.investmentListAvailable && this.state.hideModelPortfolio}, { hidden: this.state.investmentListAvailable })}>
                                                <div className="pull-right table-percent text-right" aria-label="Total - ${this.state.investmentAllocationTotal + '%'}" tabIndex="0"><span className="total">Total:</span><strong id="allocations-total">{this.state.investmentAllocationTotal}%</strong></div>
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                </div>   
                            </div>                        
                            <div className="col-md-12 col-sml-12">
                                <InlineError isHideError={this.state.isHideError}
                                        header={errorHeader}
                                        message={errorMessage}
                                        className={ClassNames('validation-margin', this.state.validationType, {'alert-right': this.state.validationError !== appConstants.ErrorCodes.Diversification})}
                                        useHtml={true} />
                            </div>
                            <div className="col-md-12 col-sml-12">
                                <InlineError isHideError={mPIsHideError || this.state.isPreRetirement}
                                        header={this.props.content.investmentAllocation.managedAccountOrModelPortfolioHeading}
                                        message={this.props.content.investmentAllocation.managedAccountOrModelPortfolio}
                                        className={ClassNames('validation-margin', this.state.mPValidationType, {'alert-right': true})}
                                        useHtml={true} />
                            </div>
                            <div className={ClassNames('term-deposit__section col-md-12 col-sml-12', { hidden: this.state.termDepositMessage })}>
                               
                                <RadioInput id="termDepositConsolidateMessage"
                                            model="isConsolidateTermDeposit"
                                            customClass="term-deposit__question"
                                            data={appConstants.YesNoRadioData}
                                            value={this.state.isConsolidateTermDeposit}
                                            label="Would you like to consolidate your contributions and rollovers before starting your term deposits?"
                                            onChange={this.setTermDeposit} />
                             
                            </div>
                             <div id="acknowledgementSection" className={ClassNames('col-md-12 col-sml-12 acknowledgement-section', { hidden: this.state.isHideAcknowledgementSection })}>
                                 <RadioButton id="isAcknowledged"
                                              name="isAcknowledged"
                                              value={this.state.isAcknowledged}
                                              label={acknowledgementLabel}
                                              model="isAcknowledged"
                                              onChange={this.updateAcknowledgement} />
                             </div>
                            <div className="col-md-12 col-sml-12">
                                <InlineError isHideError={this.state.isHideAcknowledgementError}
                                             header={acknowledgementErrorMessage}
                                             className={ClassNames('validation-margin', ValidationTypes.Warning)}
                                             useHtml={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		);
    }
});

module.exports = InvestmentAllocationSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InvestmentAllocation/InvestmentAllocationSection.jsx